import { css } from "@emotion/react";

export const gap = (size: number) => css(`gap: ${size}px;`);
